<template>

    <div class="user-activity__tile-details w-100">
        <div class="pb-0 mb-0 no-wrap font-weight-bold px-0 w-100 user-activity__description w-100">
            <span>
                <slot name="name"></slot>
            </span>
        </div>
        <div class="pb-0 mt-0 no-wrap px-0 w-100 user-activity__title">
            <slot name="description"></slot>
        </div>
    </div>

</template>